export const consultationApi = '/api/v1/consultations/';
